<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref, watch } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup(props, context) {
    const openGroups = ref([])
    provide('openGroups', openGroups)

    const setOpenGroup = title => {
      if (openGroups.value.includes(title)) {
        openGroups.value = [] // Clicou no mesmo grupo, então fecha
      } else {
        openGroups.value = [title] // Clicou em um novo, abre ele
      }
    }
    provide('setOpenGroup', setOpenGroup)

    const { root } = context

    const findActiveGroup = (items, currentRoute) => {
      const checkChild = child => {
        if (child.route && child.route.name === currentRoute.name) return true
        if (child.to && typeof child.to === 'object' && child.to.name === currentRoute.name) return true
        if (child.children) return child.children.some(checkChild)
        return false
      }

      const activeGroup = (items || []).find(item => {
        if (item.children) {
          return item.children.some(checkChild)
        }
        return false
      })

      if (activeGroup) {
        return activeGroup.title
      }
      return null
    }

    watch(
      () => root.$route.name,
      newRouteName => {
        if (!newRouteName) return

        const activeGroupTitle = findActiveGroup(props.items, root.$route)

        if (activeGroupTitle) {
          openGroups.value = [activeGroupTitle]
        }
      },
      { immediate: true },
    )
    return {
      resolveNavItemComponent,
    }
  },
}
</script>
